<template>
    <el-select v-model="selectVal" :placeholder="placeholder" multiple filterable clearable @change="toggleSelector">
        <el-option v-for="(item, index) in activeStatusList" :key="index" :label="item.title" :value="item.id"></el-option>
    </el-select>
</template>

<script>
import {
    post
} from '@/api/http.js'
import dictionary from '@/utils/dictionary';
export default {
    props: {
        value: {
            type: [Array, String, Number],
            default: function () {
                return [];
            }
        },
        withLeave: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        placeholder: {
            type: String,
            default: function () {
                return "请选择"
            }
        },
    },
    computed: {
        // 回访状态
        activeStatusList: () => {
            return dictionary.getPicker('active_status'); // this 指向的是windows
        },
    },
    data() {
        return {
            selectVal: [],
            list: []
        }
    },
    created() {

    },
    watch: {
        value: {
            handler(newVal) {
                this.selectVal = newVal;
            },
            immediate: true
        },
    },
    methods: {

        toggleSelector() {
            this.$emit('input', this.selectVal);
        }
    }
}
</script>

<style>

</style>
